import React from 'react';
import PropTypes from 'prop-types';
import {Menu, MenuItem} from '@mui/material';

/**
 * @param {Object} props
 * @param {string} props.id
 * @param {string} props.color
 * @param {Object} props.anchorEl
 * @param {Array<Object> | Array<string>} props.options
 * @param {function(string)} props.onClick
 * @param {function(*)} props.setAnchorEl
 * @constructor
 */
export function BCPDataGridMenu(props) {
    const handleClose = () => {
        props.setAnchorEl(null);
    };

    return (
        <Menu
            id={props.id}
            color={props.color}
            anchorEl={props.anchorEl}
            keepMounted
            open={Boolean(props.anchorEl)}
            onClose={handleClose}>
            {props.options.map((item, idx) => {
                if (typeof item === 'object') {
                    return (
                        <MenuItem
                            key={'bcpDataGridMenu' + props.id + idx}
                            onClick={() => {
                                props.onClick(item);
                                handleClose();
                            }}>
                            <div className={'reason-code'} style={{ backgroundColor: item.color }}>
                                {`${item.id} - ${item.description}`}
                            </div>
                        </MenuItem>
                    );
                }
                return (
                    <MenuItem
                        key={'bcpDataGridMenu' + props.id + idx}
                        onMouseEnter={(e) => (e.target.style.backgroundColor = '#C8C8C844')}
                        onMouseLeave={(e) => (e.target.style.backgroundColor = '#00000000')}
                        onClick={() => {
                            props.onClick(item);
                            handleClose();
                        }}>
                        {item}
                    </MenuItem>
                );
            })}
        </Menu>
    );
}

BCPDataGridMenu.propTypes = {
    id: PropTypes.string,
    color: PropTypes.string,
    anchorEl: PropTypes.object,
    options: PropTypes.array,
    onClick: PropTypes.func,
    setAnchorEl: PropTypes.func,
};
